import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("h4")`
    margin-top: 0;
    margin-bottom: 1rem;
    text-transform: capitalize;
    color: ${props => props.theme.uxfabric.text.primary};
    font-size: 0.938rem;
    font-family: ${({theme}) => `${theme.uxfabric.global.h4.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => theme.uxfabric.global.h4.fontWeight};
`
